(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './compose-imageLoader-image-loader.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './skiko-kjs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./compose-imageLoader-image-loader.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./skiko-kjs.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-svg'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-imageLoader-extension-svg'.");
    }
    if (typeof globalThis['compose-imageLoader-image-loader'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-svg'. Its dependency 'compose-imageLoader-image-loader' was not found. Please, check whether 'compose-imageLoader-image-loader' is loaded prior to 'compose-imageLoader-extension-svg'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-svg'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-imageLoader-extension-svg'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-svg'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-imageLoader-extension-svg'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-svg'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-imageLoader-extension-svg'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-svg'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-imageLoader-extension-svg'.");
    }
    if (typeof globalThis['skiko-kjs'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-extension-svg'. Its dependency 'skiko-kjs' was not found. Please, check whether 'skiko-kjs' is loaded prior to 'compose-imageLoader-extension-svg'.");
    }
    globalThis['compose-imageLoader-extension-svg'] = factory(typeof globalThis['compose-imageLoader-extension-svg'] === 'undefined' ? {} : globalThis['compose-imageLoader-extension-svg'], globalThis['kotlin-kotlin-stdlib'], globalThis['compose-imageLoader-image-loader'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['skiko-kjs']);
  }
}(function (_, kotlin_kotlin, kotlin_io_github_qdsfdhvh_image_loader, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_skiko_skiko) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var VOID = kotlin_kotlin.$_$.d;
  var get_mimeType = kotlin_io_github_qdsfdhvh_image_loader.$_$.m;
  var isSvg = kotlin_io_github_qdsfdhvh_image_loader.$_$.q;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var OfPainter = kotlin_io_github_qdsfdhvh_image_loader.$_$.a;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var Painter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h;
  var Companion_getInstance = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var BitmapConfig_ARGB_8888_getInstance = kotlin_io_github_qdsfdhvh_image_loader.$_$.y;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j4;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var Long = kotlin_kotlin.$_$.kn;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var Size = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var DrawCache = kotlin_org_jetbrains_compose_ui_ui.$_$.z;
  var Size__times_impl_fnp4nc = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.h1;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var convertToInt = kotlin_kotlin.$_$.le;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var equals = kotlin_kotlin.$_$.sf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var Size__hashCode_impl_2h1qpd = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.d1;
  var ImageBitmapConfig__hashCode_impl_8basqi = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h3;
  var Companion_getInstance_1 = kotlin_org_jetbrains_skiko_skiko.$_$.j;
  var SVGDOM_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.t4;
  var addSuppressed = kotlin_kotlin.$_$.eo;
  var Density = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k;
  var SVGLengthUnit_PX_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.u1;
  var SVGLength = kotlin_org_jetbrains_skiko_skiko.$_$.r5;
  var SVGPreserveAspectRatioAlign_NONE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.v1;
  var SVGPreserveAspectRatio_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.u4;
  var get_nativeCanvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.k2;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Factory, 'Factory', Factory);
  initMetadataForCompanion(Companion);
  initMetadataForClass(SvgDecoder, 'SvgDecoder', VOID, VOID, VOID, [0]);
  initMetadataForClass(SVGPainter, 'SVGPainter', VOID, Painter);
  initMetadataForClass(SkiaSvgDom, 'SkiaSvgDom');
  //endregion
  function setupSvgComponents(_this__u8e3s4, density) {
    density = density === VOID ? null : density;
    _this__u8e3s4.dy8(new Factory(density));
  }
  function isApplicable($this, source) {
    return get_mimeType(source.yya_1) === 'image/svg+xml' || isSvg(source.wya_1.iyb());
  }
  function Factory(density) {
    density = density === VOID ? null : density;
    this.xyh_1 = density;
  }
  protoOf(Factory).zy7 = function (source, options) {
    if (!isApplicable(this, source))
      return null;
    var tmp0_elvis_lhs = this.xyh_1;
    return new SvgDecoder(source.wya_1, tmp0_elvis_lhs == null ? defaultDensity(options) : tmp0_elvis_lhs, options);
  };
  function Companion() {
    this.yyh_1 = 'image/svg+xml';
  }
  var Companion_instance;
  function Companion_getInstance_2() {
    return Companion_instance;
  }
  function SvgDecoder(source, density, options) {
    this.zyh_1 = source;
    this.ayi_1 = density;
    this.byi_1 = options;
  }
  protoOf(SvgDecoder).ryf = function ($completion) {
    return new OfPainter(createSVGPainter(this.zyh_1.iyb(), this.ayi_1, this.byi_1));
  };
  protoOf(SvgDecoder).zya = function ($completion) {
    return this.ryf($completion);
  };
  function drawSvg($this, $receiver, size) {
    // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
    var canvas = $receiver.v6p().x5u();
    $this.iyi_1.ryi(canvas, size);
  }
  function SVGPainter$onDraw$lambda(this$0) {
    return function ($this$drawCachedImage) {
      drawSvg(this$0, $this$drawCachedImage, $this$drawCachedImage.o5d());
      return Unit_instance;
    };
  }
  function SVGPainter(dom, density, requestSize, bitmapConfig) {
    requestSize = requestSize === VOID ? Companion_getInstance().k5e_1 : requestSize;
    bitmapConfig = bitmapConfig === VOID ? BitmapConfig_ARGB_8888_getInstance() : bitmapConfig;
    Painter.call(this);
    this.iyi_1 = dom;
    this.jyi_1 = density;
    this.kyi_1 = requestSize;
    var tmp = this;
    var tmp_0;
    switch (bitmapConfig.a1_1) {
      case 1:
        tmp_0 = Companion_getInstance_0().x6g_1;
        break;
      case 2:
        tmp_0 = Companion_getInstance_0().a6h_1;
        break;
      case 0:
        tmp_0 = Companion_getInstance_0().y6g_1;
        break;
      case 3:
        tmp_0 = Companion_getInstance_0().b6h_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.lyi_1 = tmp_0;
    var tmp_1 = this;
    // Inline function 'kotlin.run' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'androidx.compose.ui.geometry.isSpecified' call
      var this_0 = this.kyi_1;
      if (!equalsLong(_Size___get_packedValue__impl__7rlt1o(this_0), new Long(2143289344, 2143289344))) {
        tmp$ret$1 = new Size(this.kyi_1);
        break $l$block;
      }
      var width = this.iyi_1.h5e();
      var height = this.iyi_1.i5e();
      var tmp_2;
      if (width === 0.0 && height === 0.0) {
        tmp_2 = Companion_getInstance().k5e_1;
      } else {
        // Inline function 'androidx.compose.ui.geometry.Size' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1 = fromInt(toRawBits(width));
        var v2 = fromInt(toRawBits(height));
        var tmp$ret$4 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        tmp_2 = _Size___init__impl__aywn0g(tmp$ret$4);
      }
      tmp$ret$1 = new Size(tmp_2);
    }
    tmp_1.myi_1 = tmp$ret$1.l5e_1;
    this.nyi_1 = Companion_getInstance().k5e_1;
    this.oyi_1 = 1.0;
    this.pyi_1 = null;
    this.qyi_1 = new DrawCache();
  }
  protoOf(SVGPainter).g6t = function () {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    var this_0 = this.myi_1;
    if (!equalsLong(_Size___get_packedValue__impl__7rlt1o(this_0), new Long(2143289344, 2143289344))) {
      tmp = Size__times_impl_fnp4nc(this.myi_1, this.jyi_1.u5e());
    } else {
      tmp = Companion_getInstance().k5e_1;
    }
    return tmp;
  };
  protoOf(SVGPainter).h6t = function (alpha) {
    this.oyi_1 = alpha;
    return true;
  };
  protoOf(SVGPainter).i6t = function (colorFilter) {
    this.pyi_1 = colorFilter;
    return true;
  };
  protoOf(SVGPainter).f6t = function (_this__u8e3s4) {
    if (!equals(this.nyi_1, _this__u8e3s4.o5d())) {
      this.nyi_1 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      // Inline function 'kotlin.math.ceil' call
      var x = floatFromBits(bits);
      var tmp$ret$4 = Math.ceil(x);
      var tmp0 = numberToInt(tmp$ret$4);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_1 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      // Inline function 'kotlin.math.ceil' call
      var x_0 = floatFromBits(bits_0);
      var tmp$ret$9 = Math.ceil(x_0);
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = numberToInt(tmp$ret$9);
      var tmp$ret$11 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp = _IntSize___init__impl__emcjft(tmp$ret$11);
      var tmp_0 = _this__u8e3s4.r6p();
      this.qyi_1.m9m(this.lyi_1, tmp, _this__u8e3s4, tmp_0, SVGPainter$onDraw$lambda(this));
    }
    this.qyi_1.n9m(_this__u8e3s4, this.oyi_1, this.pyi_1);
  };
  protoOf(SVGPainter).hashCode = function () {
    var result = hashCode(this.iyi_1);
    result = imul(31, result) + hashCode(this.jyi_1) | 0;
    result = imul(31, result) + Size__hashCode_impl_2h1qpd(this.kyi_1) | 0;
    result = imul(31, result) + ImageBitmapConfig__hashCode_impl_8basqi(this.lyi_1) | 0;
    return result;
  };
  protoOf(SVGPainter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SVGPainter))
      return false;
    if (!equals(this.iyi_1, other.iyi_1))
      return false;
    if (!equals(this.jyi_1, other.jyi_1))
      return false;
    if (!equals(this.kyi_1, other.kyi_1))
      return false;
    if (!(this.lyi_1 === other.lyi_1))
      return false;
    return true;
  };
  function createSVGPainter(source, density, options) {
    // Inline function 'okio.use' call
    var thrown = null;
    var tmp;
    try {
      tmp = SVGDOM_init_$Create$(Companion_getInstance_1().r5m(source.dvt()));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        thrown = t;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    finally {
      try {
        if (source == null)
          null;
        else {
          source.j4();
        }
      } catch ($p_0) {
        if ($p_0 instanceof Error) {
          var t_0 = $p_0;
          if (thrown == null) {
            thrown = t_0;
          } else {
            addSuppressed(thrown, t_0);
          }
        } else {
          throw $p_0;
        }
      }
    }
    var result = tmp;
    if (!(thrown == null))
      throw thrown;
    var dom = result;
    return new SVGPainter(new SkiaSvgDom(_SkiaSvgDom___init__impl__m161zh(dom)), density, options.cya_1);
  }
  function defaultDensity(options) {
    return Density(2.0);
  }
  function _SkiaSvgDom___init__impl__m161zh(dom) {
    return dom;
  }
  function _SkiaSvgDom___get_dom__impl__vk2cnq($this) {
    return $this;
  }
  function _SkiaSvgDom___get_width__impl__ojmy4y($this) {
    var tmp0_safe_receiver = _SkiaSvgDom___get_dom__impl__vk2cnq($this).n65();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h5e();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.s65(SVGLengthUnit_PX_getInstance());
    var tmp0_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.q65_1;
    return tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  }
  function _SkiaSvgDom___get_height__impl__a7vjkv($this) {
    var tmp3_safe_receiver = _SkiaSvgDom___get_dom__impl__vk2cnq($this).n65();
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.i5e();
    var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.s65(SVGLengthUnit_PX_getInstance());
    var tmp0_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.q65_1;
    return tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  }
  function SkiaSvgDom__draw_impl_pyhll1($this, canvas, size) {
    var tmp6_safe_receiver = _SkiaSvgDom___get_dom__impl__vk2cnq($this).n65();
    if (tmp6_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(size);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp$ret$0 = floatFromBits(bits);
      tmp6_safe_receiver.d66(new SVGLength(tmp$ret$0, SVGLengthUnit_PX_getInstance()));
    }
    var tmp7_safe_receiver = _SkiaSvgDom___get_dom__impl__vk2cnq($this).n65();
    if (tmp7_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$4 = floatFromBits(bits_0);
      tmp7_safe_receiver.e66(new SVGLength(tmp$ret$4, SVGLengthUnit_PX_getInstance()));
    }
    var tmp8_safe_receiver = _SkiaSvgDom___get_dom__impl__vk2cnq($this).n65();
    if (tmp8_safe_receiver == null)
      null;
    else {
      tmp8_safe_receiver.f66(SVGPreserveAspectRatio_init_$Create$(SVGPreserveAspectRatioAlign_NONE_getInstance()));
    }
    _SkiaSvgDom___get_dom__impl__vk2cnq($this).o65(get_nativeCanvas(canvas));
  }
  function SkiaSvgDom__toString_impl_1r4k0j($this) {
    return 'SkiaSvgDom(dom=' + $this.toString() + ')';
  }
  function SkiaSvgDom__hashCode_impl_k01csc($this) {
    return $this.hashCode();
  }
  function SkiaSvgDom__equals_impl_bdlgm8($this, other) {
    if (!(other instanceof SkiaSvgDom))
      return false;
    var tmp0_other_with_cast = other instanceof SkiaSvgDom ? other.syi_1 : THROW_CCE();
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function SkiaSvgDom(dom) {
    this.syi_1 = dom;
  }
  protoOf(SkiaSvgDom).h5e = function () {
    return _SkiaSvgDom___get_width__impl__ojmy4y(this.syi_1);
  };
  protoOf(SkiaSvgDom).i5e = function () {
    return _SkiaSvgDom___get_height__impl__a7vjkv(this.syi_1);
  };
  protoOf(SkiaSvgDom).ryi = function (canvas, size) {
    return SkiaSvgDom__draw_impl_pyhll1(this.syi_1, canvas, size);
  };
  protoOf(SkiaSvgDom).toString = function () {
    return SkiaSvgDom__toString_impl_1r4k0j(this.syi_1);
  };
  protoOf(SkiaSvgDom).hashCode = function () {
    return SkiaSvgDom__hashCode_impl_k01csc(this.syi_1);
  };
  protoOf(SkiaSvgDom).equals = function (other) {
    return SkiaSvgDom__equals_impl_bdlgm8(this.syi_1, other);
  };
  //region block: init
  Companion_instance = new Companion();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = setupSvgComponents;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-imageLoader-extension-svg.js.map
